import type { WUserAccountTranslations } from "./pl";

export const de: WUserAccountTranslations = {
  loginButton: "Anmelden",
  greeting: "Hallo, {name}",
  defaultGreetingName: "Benutzer",

  modalTitle: "Anmelden",
  modalClose: "Schließen",

  loginLabel: "Login oder E-Mail",
  passwordLabel: "Passwort",
  submitLogin: "Anmelden",
  submitLoginBusy: "Anmeldung läuft…",
  registerLink: "Konto erstellen",
  forgotPasswordLink: "Passwort vergessen",

  validationLoginRequired: "Login oder E-Mail-Adresse eingeben.",
  validationPasswordRequired: "Passwort eingeben.",

  loginFailed: "Anmeldung fehlgeschlagen.",
  networkError: "Netzwerkfehler.",

  myAccountLink: "Mein Konto",
  logoutAction: "Abmelden",
  logoutFailed: "Abmelden fehlgeschlagen.",

  errorNotLinked: "Widget ist nicht mit einem Benutzerkonten-Katalog verknüpft. Kontaktiere den Administrator.",
  errorCatalogMissing: "Verknüpfter Benutzerkonten-Katalog existiert nicht. Kontaktiere den Administrator.",
  errorFetchFailed: "Widget konnte nicht geladen werden.",
};
